import { z } from 'zod';

import { isoTimestampSchema, uuidSchema } from './primitives.js';

export const messageTypeSchema = z.enum([
  'client_email',
  'staff_email',
  'internal_note',
  'system_event',
]);

export const messageAttachmentRefSchema = z.object({
  id: uuidSchema,
  filename: z.string().min(1),
  mimeType: z.string().min(1),
  sizeBytes: z.number().int().nonnegative(),
});

export const messageSchema = z.object({
  id: uuidSchema,
  ticketId: uuidSchema,
  authorUserId: uuidSchema.nullable(),
  type: messageTypeSchema,
  bodyHtml: z.string().nullable(),
  bodyText: z.string(),
  attachments: z.array(messageAttachmentRefSchema),
  emailMessageId: z.string().nullable(),
  createdAt: isoTimestampSchema,
});

export const replyComposeInputSchema = z.object({
  bodyHtml: z.string().min(1),
  bodyText: z.string().min(1),
  attachmentIds: z.array(uuidSchema).default([]),
});

export const internalNoteInputSchema = z.object({
  bodyText: z.string().min(1),
  bodyHtml: z.string().nullable(),
});
